import { ReviewActionButtons } from "./ActionButtons/ReviewActionButtons";
import { SidebarHeader } from "@/components/layout/SidebarHeader";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useCurrentMedia, useFlattenedVideoSourceId } from "@/store";
import { useReviewTab } from "./ReviewContext";
import { ReviewTab } from "./ReviewTabs";

export const ReviewSidebarContent = () => {
    const { hasEnoughDataToDeploy } = useComputedValues();
    const currentMedia = useCurrentMedia();
    const { activeTab } = useReviewTab();
    const flattenedVideoSourceId = useFlattenedVideoSourceId();

    // When flattened, currentMedia.file is a frame (isVideo=false), but the
    // underlying media is still a video. Use flattenedVideoSourceId to detect this.
    const isVideo = currentMedia?.file.isVideo || !!flattenedVideoSourceId;
    const shouldShowDeployFlow = isVideo || hasEnoughDataToDeploy;
    const isAnnotationsView = activeTab === ReviewTab.MyAnnotations;

    let title: string;
    let description: string | undefined;

    if (isAnnotationsView) {
        title = "Your annotations";
        description =
            "These are the objects you drew. Compare them with the draft model predictions.";
    } else if (shouldShowDeployFlow) {
        title = "How is your model looking?";
        description =
            "You can adjust the slider to show more or less objects before taking your next action.";
    } else {
        title = "Let's try on more data.";
        description = "Upload more images or a video to improve your model.";
    }

    return (
        <>
            <SidebarHeader title={title} description={description} />
            <ReviewActionButtons forceVideoFlow={shouldShowDeployFlow} />
        </>
    );
};
